<template>
  <v-btn
    v-for="action, key of enabledActions"
    :key="key"
    :title="title(action, key)"
    icon
    :disabled="$loader.loading"
    density="compact"
    min-height="32"
    min-width="32"
    elevation="1"
    class="mr-2 pa-2"
    @click="action.callback(item.item)"
  >
    <v-icon
      :color="action.color"
      :icon="icon(action, key)"
      size="x-small"
    />
  </v-btn>

  <slot name="custom.actions" :item="item.item" />
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import type { DataTableAction, DefaultDataTableActions, DefaultDataTableActionsKey } from '@/types/DataTable'

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
    actions: {
      type: Object as PropType<DefaultDataTableActions>,
      required: true,
    },
  },
  computed: {
    enabledActions(): Record<DefaultDataTableActionsKey, DataTableAction> {
      return Object.fromEntries(
        Object.entries(this.actions).filter(
          ([, value]) => value.condition === undefined || value.condition(this.item.item),
        ),
      ) as Record<DefaultDataTableActionsKey, DataTableAction> // only using "as" here cause i'm sure the actions keys matches
    },
  },
  methods: {
    icon(action: DataTableAction, key: DefaultDataTableActionsKey): string {
      if (action.icon) return action.icon

      const defaults: Partial<Record<DefaultDataTableActionsKey, string>> = {
        create: 'fa-solid fa-plus',
        read: 'fa-solid fa-magnifying-glass',
        update: 'fa-solid fa-pen',
        destroy: 'fa-solid fa-trash',
        access: 'fa-solid fa-lock',
        restore: 'fa-solid fa-trash',
      }

      if (defaults[key] === undefined) return 'fa-solid fa-bomb'

      return defaults[key]
    },
    color(action: DataTableAction, key: DefaultDataTableActionsKey): string {
      if (action.icon) return action.icon

      const defaults: Partial<Record<DefaultDataTableActionsKey, string>> = {
        create: 'success',
        read: 'primary',
        update: 'info',
        destroy: 'error',
        access: 'grey',
        restore: 'info',
      }

      if (defaults[key] === undefined) return 'fa-solid fa-bomb'

      return defaults[key]
    },
    title(action: DataTableAction, key: DefaultDataTableActionsKey): string {
      if (action.title) return action.title

      const defaults: Partial<Record<DefaultDataTableActionsKey, string>> = {
        create: 'Criar',
        read: 'Visualizar',
        update: 'Editar',
        destroy: 'Excluir',
        access: 'Acessar',
        restore: 'Restaurar',
      }

      if (defaults[key] === undefined) return ''

      return defaults[key]
    },
    deleteDialog(item: unknown): void {
      this.$dialog.open({
        title: 'Confirmação de exclusão',
        message: 'Realmente deseja excluir o item?',
      })
        .then(
          async (confirm: unknown) => {
            if (confirm) {
              await this.actions.destroy?.callback(item)
            // this.fetch(this.options.page);
            }
          },
        )
    },
    restoreDialog(item: unknown): void {
      this.$dialog.open({
        title: 'Confirmação de Restauração',
        message: 'Realmente deseja restaurar o item?',
      })
        .then(
          async (confirm: unknown) => {
            if (confirm) {
              await this.actions.restore?.callback(item)
            // this.fetch(this.options.page);
            }
          },
        )
    },
  },
})
</script>
